import { t, huidigeTaal, geleden } from '../i18n.js';
import { CONTROLES } from '../beveiligingsstatus.js';

/**
 * De uitkomst van de controle van één maildomein (docs/ontwerp/snelle-start.md): per controle de stand en wat het
 * betekent. Op de beveiligingsstatus en onder Beheer › Klanten › Maildomein.
 */
const taal = (x) => x?.[huidigeTaal()] ?? x?.nl ?? '';
const vul = (s, w = {}) => s.replace(/\{(\w+)\}/g, (_, k) => (w[k] == null || w[k] === '' ? '—' : String(w[k])));
const kleur = { goed: 'goed', aandacht: 'deels', fout: 'zelf', onbekend: 'onbekend' };
const STAND = { goed: 'In orde', aandacht: 'Kan beter', fout: 'Niet in orde', onbekend: 'Onbekend' };

export function tekstVan(c) {
  const x = CONTROLES.find((k) => k.id === c.id);
  if (!x) return c.id;
  const s = (c.params?.waarom && x[`${c.stand}_${c.params.waarom}`]) || x[c.stand] || (c.stand === 'onbekend' ? null : x.goed);
  return s ? vul(taal(s), c.params) : t('Niet te controleren.');
}

export default function DomeinControle({ d }) {
  return (
    <div className="dc">
      <div className="dc-kop">
        <b className="mono">{d.domain}</b>
        {d.score != null && <span className={`bs-chip ${d.score >= 80 ? 'goed' : d.score >= 60 ? 'deels' : 'zelf'}`}>{t('{n} van 100', { n: d.score })}</span>}
        <span className="muted">{d.checkedAt ? t('gecontroleerd {tijd}', { tijd: geleden(d.checkedAt) }) : t('nog niet gecontroleerd')}</span>
      </div>
      {d.error && <div className="callout warn">{d.error}</div>}
      {d.checks.length > 0 && (
        <ul className="dc-lijst">{d.checks.map((c) => (
          <li key={c.id} className={kleur[c.stand]}>
            <span className={`bs-chip ${kleur[c.stand]}`}>{t(STAND[c.stand])}</span>
            <span><b>{taal(CONTROLES.find((k) => k.id === c.id)?.naam)}</b>{c.id === 'mx' && c.params?.dienst && <span className="muted"> · {c.params.dienst}</span>}<br />
              <span className="soft">{tekstVan(c)}</span></span>
          </li>
        ))}</ul>
      )}
    </div>
  );
}
